// /children DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정(레이아웃 결정성 확보, 헤더 잘림 해결).
// 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리된다.

import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { EditButton } from "@refinedev/mui";
import { OverflowTooltip } from "components/list";
import { IChild } from "../interfaces";

// 수정일: 날짜 + 시간(오전/오후) 문자열로 포맷 (현행 로직 유지)
const formatUpdatedDate = (value: unknown): string => {
  const date = new Date(value as string);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const amPm = hours < 12 ? "오전" : "오후";
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일 ${amPm} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const childrenColumns: GridColDef<IChild>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "name",
    headerName: "이름",
    type: "string",
    width: 160,
    minWidth: 120,
  },
  {
    field: "parentId",
    headerName: "학부모ID",
    type: "string",
    width: 110,
    minWidth: 90,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "centerId",
    headerName: "센터ID",
    type: "string",
    width: 100,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "updatedDate",
    headerName: "수정일",
    type: "string",
    width: 236,
    minWidth: 190,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={formatUpdatedDate(params.value)} />
    ),
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    minWidth: 90,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <EditButton hideText recordItemId={params.row.id} />
    ),
  },
];
